import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ChartType } from './dashboard.model';
import { ToasterNotificationService } from 'src/app/core/services/toaster-notification.service';
import { AuthMyfileService, UserContextType } from 'src/app/core/services/auth.myfile.service';
import { ClientModel } from 'src/app/core/models/members/client/client.model';
import { MyfileChartModel } from 'src/app/core/models/myfile-chart.model';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { dateSelectOptionsList, GlobalComponent } from 'src/app/global-component';
import { RequisitionStatusSummaryModel } from 'src/app/core/models/requisition/requisition-status-summary-model.model';
import { ClientSearchModel } from 'src/app/core/models/members/client/client-search-model';
import { ContactSearchModal } from 'src/app/core/models/contact/contacts-search.model';
import { LoginType } from 'src/app/core/models/members/user/user-context.model';
import { SecurityOperations } from 'src/app/core/security/security-operations';
import { RequisitionSearchModel } from 'src/app/core/models/requisition/requisition-search.model';

export class RequisitionStatusSummaryListState extends RequisitionSearchModel {
  from?: string;
  to?: string;
}

export class ProgressChartDataModel {
  clientId?: string;
  from?: string;
  to?: string;
  categories: string[] = [];
  draftsData: number[] = [];
  submittedData: number[] = [];
  processingData: number[] = [];
  completedData: number[] = [];
  incompleteData: number[] = [];
}

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],

})

/**
 * Ecommerce Component
 */
export class DashboardComponent implements OnInit {

  // bread crumb items
  breadCrumbItems!: Array<{}>;

  witnessChart!: ChartType;
  myfileChart!: ChartType;
  barChart!: ChartType;
  donutChart!: ChartType;

  loginType?: LoginType = this.authService.currentUserContextValue?.loginType;

  timeLineOwnerId?: string = this.authService.currentUserContextValue?.id;

  dateSelectOptions = GlobalComponent.dateSelectOptionsList;

  canViewRequisitionList = this.authService.canAccessOperation(SecurityOperations.requisition.requisitionManagement);

  dashboardDataModel: RequisitionStatusSummaryModel = new RequisitionStatusSummaryModel;

  searchModel: RequisitionStatusSummaryListState = {
    sortColumnDirective: 'modifiedDate',
    sortDirectionDirective: 'desc',
    pageSize: GlobalComponent.defaultPagingInfo.pageSize,
    pageIndex: 0,
    startIndex: 1,
    sortColumn: '',
    sortDirection: 'desc',
    searchTerm: '',
    from: '2023-01-01T00:00:00',
    to: '2023-12-31T00:00:00'
  };
  todayDate = new Date();

  progressChartsModel: ProgressChartDataModel = new ProgressChartDataModel();

  userContext: UserContextType = this.authService.currentUserContextValue;
  dateSelectTypeSelected: string = GlobalComponent.dateSelectOptionsList[3].value;
  // Current Dates
  currentDate: string = GlobalComponent.dateTransform(this.convertDateToString(this.todayDate), false);
  datePattern = GlobalComponent.datePattern;

  clientStatsModel: ClientModel = new ClientModel();

  witnessChartValues = {
    series: [{
      name: 'Draft',
      type: 'line',
      data: this.progressChartsModel.draftsData
    }, {
      name: 'Submitted',
      type: 'line',
      data: this.progressChartsModel.submittedData
    }],
    color: '["--vz-secondary", "--vz-primary"]',
  }

  myfileChartValues = {
    series: [{
      name: 'Processing',
      type: 'line',
      data: this.progressChartsModel.processingData
    }, {
      name: 'Completed',
      type: 'line',
      data: this.progressChartsModel.completedData
    }, {
      name: 'Incomplete',
      type: 'line',
      data: this.progressChartsModel.incompleteData
    }],
    color: '["--vz-warning", "--vz-success", "--vz-danger"]',
  }

  constructor(public toastService: ToasterNotificationService,
    private chageDetector: ChangeDetectorRef,
    private myFileApiService: MyfileApiService,
    public authService: AuthMyfileService,) {
  }

  ngOnInit(): void {
    /**
     * BreadCrumb
     */

    this.breadCrumbItems = [
      { label: 'Dashboards' },
      { label: 'Dashboard', active: true }
    ];

    /**
    * Fetches the data
    */
    this.fetchData();
    this._barChart('["--vz-primary", "--vz-success", "--vz-warning"]');
    this.witnessChart = this._progressChart(this.witnessChartValues, 2);
    this.myfileChart = this._progressChart(this.myfileChartValues, 3);
  }

  convertDateToString(date: Date): string {
    var stringDate: string = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate() + "T00:00:00Z";
    if (stringDate.split('-')[1].length == 1) {
      stringDate = `${stringDate.split('-')[0]}-0${stringDate.split('-')[1]}-${stringDate.split('-')[2]}`
    }
    if (stringDate.split('-')[2].split('T')[0].length == 1) {
      stringDate = `${stringDate.split('-')[0]}-${stringDate.split('-')[1]}-0${stringDate.split('-')[2]}`
    }
    return stringDate;
  }

  dateSubtractMonths(date: Date, months: number) {
    const dateCopy = new Date(date);
    dateCopy.setMonth(dateCopy.getMonth() - months);
    return dateCopy;
  }
  dateSubtractWeeks(date: Date, weeks: number) {
    const dateCopy = new Date(date);
    dateCopy.setDate(dateCopy.getDate() - (weeks * 7));
    return dateCopy;
  }
  exactDateChosen() {
    if (this.currentDate.length == 10) {
      this.fetchData();
    }
  }

  dateChosen() {
    switch (this.dateSelectTypeSelected) {
      case dateSelectOptionsList.month:
        this.searchModel.from = this.convertDateToString(this.dateSubtractMonths(this.todayDate, 1))
        this.searchModel.to = this.convertDateToString(this.todayDate)
        break;
      case dateSelectOptionsList.allTime:
        if (this.authService.currentUserContextValue?.authContext?.createdDate) {
          this.searchModel.from = this.authService.currentUserContextValue?.authContext?.createdDate.toString();
        } else {
          this.searchModel.from = undefined
        }
        this.searchModel.to = this.convertDateToString(this.todayDate);
        break;
      case dateSelectOptionsList.year:
        this.searchModel.from = this.convertDateToString(this.dateSubtractMonths(this.todayDate, 12))
        this.searchModel.to = this.convertDateToString(this.todayDate)
        break;
      case dateSelectOptionsList.exactDate:
        if (this.currentDate.length == 10) {
          this.searchModel.from = GlobalComponent.dateTransform(this.currentDate, true)
          this.searchModel.to = GlobalComponent.dateTransform(this.currentDate, true)
        }
        break;
      case dateSelectOptionsList.sixMonths:
        this.searchModel.from = this.convertDateToString(this.dateSubtractMonths(this.todayDate, 6))
        this.searchModel.to = this.convertDateToString(this.todayDate)
        break;
      case dateSelectOptionsList.week:
        this.searchModel.from = this.convertDateToString(this.dateSubtractWeeks(this.todayDate, 1))
        this.searchModel.to = this.convertDateToString(this.todayDate)
        break;
    }

  }
  clientChosen(result: ClientModel) {
    this.clientStatsModel = result;
    this.progressChartsModel.clientId = result.id;

    this.searchModel.searchTerm = result.email;

    if (result.id) {
      if (!this.searchModel.clientSearch) {
        this.searchModel.clientSearch = new ClientSearchModel;
      }
      this.searchModel.clientSearch.searchTerm = this.searchModel.searchTerm;
      if (!this.searchModel.accountSearch) {
        this.searchModel.accountSearch = new ContactSearchModal;
      }
      this.searchModel.accountSearch.searchTerm = this.searchModel.searchTerm;
    } else {
      this.searchModel.searchTerm = ''
      this.searchModel.clientSearch = undefined
      this.searchModel.accountSearch = undefined
    }
    this.fetchData();
    this.chageDetector.detectChanges();
  }

  // Chart Colors Set
  private getChartColorsArray(colors: any) {
    colors = JSON.parse(colors);
    return colors.map(function (value: any) {
      var newValue = value.replace(" ", "");
      if (newValue.indexOf(",") === -1) {
        var color = getComputedStyle(document.documentElement).getPropertyValue(newValue);
        if (color) {
          color = color.replace(" ", "");
          return color;
        }
        else return newValue;;
      } else {
        var val = value.split(',');
        if (val.length == 2) {
          var rgbaColor = getComputedStyle(document.documentElement).getPropertyValue(val[0]);
          rgbaColor = "rgba(" + rgbaColor + "," + val[1] + ")";
          return rgbaColor;
        } else {
          return newValue;
        }
      }
    });
  }

  setLines(numLines: number, numValue: number): number[] {
    var array = []
    for (let index = 0; index < numLines; index++) {
      array.push(numValue)
    }
    return array;
  }
  private _progressChart(chartValues: any, lines: number) {

    return {
      chart: {
        height: 370,
        type: "line",

        toolbar: {
          show: false,
        },
      },
      stroke: {
        curve: "straight",
        dashArray: this.setLines(lines, 0),
        width: this.setLines(lines, 2),
      },
      colors: this.getChartColorsArray(chartValues.color),
      series: chartValues.series,
      fill: {
        opacity: this.setLines(lines, 1),
      },
      markers: {
        size: this.setLines(lines, 0),
        strokeWidth: 2,
        hover: {
          size: 4,
        },
      },
      xaxis: {
        categories: this.progressChartsModel.categories,
        axisTicks: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
      },
      grid: {
        show: false,
      },
    };
  }
  private _barChart(colors: any) {
    colors = this.getChartColorsArray(colors);
    this.barChart = {
      series: [],
      chart: {
        type: 'bar',
        height: 350,
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '65%',
        },
      },
      stroke: {
        show: true,
        width: 5,
        colors: ['transparent']
      },
      xaxis: {
        categories: [''],
        axisTicks: {
          show: false,
          borderType: 'solid',
          color: '#78909C',
          height: 6,
          offsetX: 0,
          offsetY: 0
        },
      },
      yaxis: {
        labels: {
          formatter: function (value: any) {
            //return "$" + value + "k";
            return value;
          }
        },
        tickAmount: 4,
        min: 0
      },
      fill: {
        opacity: 1
      },
      legend: {
        show: true,
        position: 'bottom',
        horizontalAlign: 'center',
        fontWeight: 500,
        offsetX: 0,
        offsetY: -14,
        itemMargin: {
          horizontal: 8,
          vertical: 0
        },
        markers: {
          width: 10,
          height: 10,
        }
      },
      colors: colors
    };

    this.donutChart = {
      series: [this.dashboardDataModel.totalSubmitted, this.dashboardDataModel.totalCompleted, this.dashboardDataModel.totalProcessing, this.dashboardDataModel.totalIncompleted, this.dashboardDataModel.totalDraft],
      chart: {
        type: "donut",
        height: 350,
      },
      labels: ["Submitted", "Completed", "Processing", "Incomplete", "Drafts"],
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: "bottom"
            }
          }
        }
      ]
    };
  }
  setDonutChart() {
    this.donutChart.series = [this.dashboardDataModel.totalSubmitted, this.dashboardDataModel.totalCompleted, this.dashboardDataModel.totalProcessing, this.dashboardDataModel.totalIncompleted, this.dashboardDataModel.totalDraft];
  }
  /**
  * Fetches the data
  */
  fetchData() {
    this.myFileApiService.getMyFileDocumentStatusSummaryReport()
      .subscribe(res => {
        this.loadMyFileDocumentStatusChart(res);
      });
    this.dateChosen();

    this.myFileApiService.getRequisitionStatusSummary(this.searchModel)
      .subscribe((result?: RequisitionStatusSummaryModel) => {
        if (result) {
          this.dashboardDataModel = result;
          this.clearCharts();
          if (result.data) {
            result.data.forEach(data => {
              this.progressChartsModel.categories.push(this.convertDateToTitle(data.date!));
              this.progressChartsModel.draftsData.push(data.draft!);
              this.progressChartsModel.submittedData.push(data.submitted!);
              this.progressChartsModel.processingData.push(data.processing!);
              this.progressChartsModel.completedData.push(data.completed!);
              this.progressChartsModel.incompleteData.push(data.incompleted!);
            });
          }
          this.witnessChart.series[0].data = this.progressChartsModel.draftsData;
          this.witnessChart.series[1].data = this.progressChartsModel.submittedData;
          this.myfileChart.series[0].data = this.progressChartsModel.processingData;
          this.myfileChart.series[1].data = this.progressChartsModel.completedData;
          this.myfileChart.series[2].data = this.progressChartsModel.incompleteData;

          this.witnessChart = this._progressChart(this.witnessChartValues, 2);
          this.myfileChart = this._progressChart(this.myfileChartValues, 3);
          this.setDonutChart();
        }
      });

  }

  convertDateToTitle(date: Date): string {
    var string = date.toString().split('T')[0];
    string = `${string.split('-')[1]}-${string.split('-')[0]}`;
    return string;
  }

  clearCharts() {
    this.progressChartsModel.categories = [];
    this.progressChartsModel.draftsData = [];
    this.progressChartsModel.submittedData = [];
    this.progressChartsModel.processingData = [];
    this.progressChartsModel.completedData = [];
    this.progressChartsModel.incompleteData = [];
  }

  private loadMyFileDocumentStatusChart(chart: MyfileChartModel | undefined) {
    if (chart) {
      var data = Array<any>();

      chart.data.forEach(x => {
        data.push({
          name: x.status,
          data: [x.count]
        });
      });

      this.barChart.series = data;
    }
  }
  /**
   * Recent Activity
   */
  toggleActivity() {
    const recentActivity = document.querySelector('.layout-rightside-col');
    if (recentActivity != null) {
      recentActivity.classList.toggle('d-none');
    }

    if (document.documentElement.clientWidth <= 1399) {
      const recentActivity = document.querySelector('.layout-rightside-col');
      if (recentActivity != null) {
        recentActivity.classList.add('d-block');
        recentActivity.classList.remove('d-none');
      }
    }
  }

  stringLengthValidation(date: string | undefined): number {
    if (date == undefined) {
      return 0;
    } else {
      if (this.currentDate.length == 8) {
        if (!this.currentDate.includes('/')) {
          this.currentDate = this.currentDate.substring(0, 2) + "/" + this.currentDate.substring(2, 4) + "/" + this.currentDate.substring(4, 8)
        }
      }
      return date.length
    }
  }
  /**
   * SidebarHide modal
   * @param content modal content
   */
  SidebarHide() {
    const recentActivity = document.querySelector('.layout-rightside-col');
    if (recentActivity != null) {
      recentActivity.classList.remove('d-block');
    }
  }

  ngOnDestroy() {
  
  }
}
